type GetMetaDescription = (conditions: {
  brandName?: string
  searchWord?: string
  shopType?: 'all' | 'apparel' | 'salon'
}) => string

export const getMetaDescription: GetMetaDescription = ({
  brandName,
  searchWord,
  shopType = 'all',
}): string => {
  const brandAndSearchWordText =
    brandName && searchWord
      ? `${brandName}を取扱い、「${searchWord}」に該当する`
      : brandName
        ? `${brandName}を取扱う`
        : searchWord
          ? `「${searchWord}」に該当する`
          : ''
  const shopText =
    shopType === 'apparel'
      ? 'アパレルショップ'
      : shopType === 'salon'
        ? '美容室'
        : '店舗'
  return `${brandAndSearchWordText}${shopText}一覧です。WEARはモデル・俳優・ショップスタッフなどの着こなしをチェックできるファッションコーディネートサイトです。`
}
